import { webApi } from '@lib/api'

export const listCategory = () => webApi({ auth: true }).get('/v1/categories')
